// extracted by mini-css-extract-plugin
module.exports = {"oamMenuWrapper":"oam-sider_oamMenuWrapper__TqRry"};